import {
    COMPANY_LIST_LOADED,
    COMPANY_DETAILS_LOADED,
    UNSYNCED_LIST_LOADED,
    LOADING_COMPANYLIST,
    COMPANY_SELECTED,
    COMPANY_VALIDATED,
    SETUP_COMPANY_LIST_LOADED,
    AGREEMENT_SELECTED,
    AGREEMENT_LIST_LOADED,
    SELECTED_COMPANY_UPDATED,
    COMPANY_AUDIT_LOADED,
    COMPANY_DETAILS_USERS_UPDATED,
    COMPANY_SYNC_LOADING,
    DISMISS_TOAST,
    ADD_TOAST,
    COMPANY_HISTORY_LOADED,
    LOADING_COMPANY_HISTORY,
    LOADING_COMPANY_AUDIT,
    COMPANY_SETTINGS_LOADED,
    LOADING_COMPANY_SETTINGS,
    USER_UPDATE_SUCCESS,
    USER_EXCLUDE_SUCCESS,
} from './companyTypes'

export const handleCompanyLoading = () => {
    return {
        type: LOADING_COMPANYLIST,
    }
}

export const handleUpdateSuccess = (payload) => {
    return {
        type: USER_UPDATE_SUCCESS,
        payload: payload,
    }
}

export const handleExcludeSuccess = (payload) => {
    return {
        type: USER_EXCLUDE_SUCCESS,
        payload: payload,
    }
}

export const handleCompanySettingsLoading = () => {
    return {
        type: LOADING_COMPANY_SETTINGS,
    }
}

export const handleCompanyHistoryLoading = () => {
    return {
        type: LOADING_COMPANY_HISTORY,
    }
}

export const handleCompanyAuditLoading = () => {
    return {
        type: LOADING_COMPANY_AUDIT,
    }
}

export const unsyncedListLoaded = (payload) => {
    return {
        type: UNSYNCED_LIST_LOADED,
        payload: payload,
    }
}

export const companyListLoaded = (payload) => {
    return {
        type: COMPANY_LIST_LOADED,
        payload: payload,
    }
}

export const companySelected = (payload) => {
    return {
        type: COMPANY_SELECTED,
        payload: payload,
    }
}

export const agreementSelected = (payload) => {
    return {
        type: AGREEMENT_SELECTED,
        payload: payload,
    }
}

export const handleSyncCompanyLoadingToggle = () => {
    return {
        type: COMPANY_SYNC_LOADING,
    }
}

export const companyCredentialsValidated = (payload) => {
    return {
        type: COMPANY_VALIDATED,
        payload: payload,
    }
}

export const companyDetailsUsersUpdated = (payload) => {
    return {
        type: COMPANY_DETAILS_USERS_UPDATED,
        payload: payload,
    }
}

export const companyAuditLoaded = (payload) => {
    return {
        type: COMPANY_AUDIT_LOADED,
        payload: payload,
    }
}

export const companySettingsLoaded = (payload) => {
    return {
        type: COMPANY_SETTINGS_LOADED,
        payload: payload,
    }
}

export const companyHistoryLoaded = (payload) => {
    return {
        type: COMPANY_HISTORY_LOADED,
        payload: payload,
    }
}

export const companyDetailsLoaded = (payload) => {
    return {
        type: COMPANY_DETAILS_LOADED,
        payload: payload,
    }
}

export const setupCompanyListLoaded = (payload) => {
    return {
        type: SETUP_COMPANY_LIST_LOADED,
        payload: payload,
    }
}

export const agreementListLoaded = (payload) => {
    return {
        type: AGREEMENT_LIST_LOADED,
        payload: payload,
    }
}

export const handleUpdateSelectedCompany = (payload) => {
    return {
        type: SELECTED_COMPANY_UPDATED,
        payload: payload,
    }
}

export const addSaveToast = (payload) => {
    return {
        type: ADD_TOAST,
        payload: { type: 'save', payload: payload },
    }
}

export const addWarningToast = (payload) => {
    return {
        type: ADD_TOAST,
        payload: { type: 'warning', payload: payload },
    }
}

export const addErrorToast = (payload) => {
    return {
        type: ADD_TOAST,
        payload: { type: 'error', payload: payload },
    }
}

export const addDeleteToast = (payload) => {
    return {
        type: ADD_TOAST,
        payload: { type: 'delete', payload: payload },
    }
}

export const handleDismissSucessAlert = () => {
    return {
        type: DISMISS_TOAST,
    }
}